import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { Chart, TooltipItem } from 'chart.js';
import { MillionPipe } from '../../pipes/million.pipe';

@Component({
    selector: 'app-forecast-data-bar-chart',
    templateUrl: './forecast-data-bar-chart.component.html',
    styleUrls: ['./forecast-data-bar-chart.component.scss'],
    standalone: false
})
export class ForecastDataBarChartComponent implements OnInit, AfterViewInit {

  @Input() chartData: any;
  @Input() chartId!: string;
  barChart: any;
  millionPipe: MillionPipe = new MillionPipe;

  constructor() { }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.generateChart();
  }

  private getMinValue(datasets: any) {
    let minVal = 0;
    for (let dataset of datasets) {
      const data = dataset.data.filter((item: any) => item !== null);
      if (minVal === 0)
        minVal = Math.min(...data)
      else
        minVal = Math.min(...data, minVal)
    }
    return minVal;
  }

  private generateChart(): void {
    //  const minVal = this.getMinValue(this.chartData.datasets)
    this.barChart = new Chart(this.chartId, {
      type: 'bar',
      data: this.chartData,
      options: {
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            mode: 'index',
            backgroundColor: '#ffffff',
            borderColor: "#333333",
            borderWidth: 1,
            titleColor: '#858585',
            padding: 12,
            displayColors: false,
            callbacks: {
              title: (): string => {
                return '';
              },
              labelTextColor: (): string => {
                return '#333333';
              },
              label: (tooltipItem: TooltipItem<'bar'>): string => {
                const datasetLabel = tooltipItem.dataset.label ?? '';
                const value = tooltipItem.raw as number;
                return `${datasetLabel}: ${this.millionPipe.transform(value)}`;
              }

            }
          }
        },
        maintainAspectRatio: false,
        scales: {
          x: {
            grid: {
              display: false,
            },
          },
          y: {
            beginAtZero: true,
            ticks: {
              // min: minVal*0.5,
              callback: (value: string | number): string => { return this.millionPipe.transform(value) }
            },
            grid: {
              // drawBorder: false - deprecated in Chart.js v3, use border.display instead
            },
          },
        }
      },

    });
  }



}
